import { Button } from '@common/components/atom/Button/Button';
import { Input } from '@common/components/atom/Input/Input';
import { InputDecorator } from '@common/components/atom/InputDecorator/InputDecorator';
import { Modal } from '@common/components/atom/Modal/Modal';
import { Radio } from '@common/components/atom/Radio/Radio';
import React, { useState } from 'react';

import type { CustomLinkOptions } from '../_utils/CustomLink';

interface LinkButtonProps {
  onClick: () => void;
  selectedOptions: CustomLinkOptions;
  onHrefChange: (href: CustomLinkOptions['href']) => void;
  onThemeChange: (theme: CustomLinkOptions['theme']) => void;
  onIsOutLinkChange: (isOutLink: boolean) => void;
  onSizeChange: (size: CustomLinkOptions['size']) => void;
  onSubmit: () => void;
}

/**
 * 에디터 툴바의 버튼으로 각종 링크 추가 가능
 */
export const LinkButton = ({
  onClick,
  selectedOptions,
  onHrefChange,
  onThemeChange,
  onIsOutLinkChange,
  onSizeChange,
  onSubmit,
}: LinkButtonProps) => {
  const [isModalOpened, setIsModalOpened] = useState(false);

  const isButtonSelected =
    selectedOptions.theme === 'primary-fill-button' ||
    selectedOptions.theme === 'sub-fill-button' ||
    selectedOptions.theme === 'blue-fill-button';

  return (
    <>
      <Button
        dimensions="H26"
        roundness="rectangle"
        onClick={() => {
          setIsModalOpened(true);
          onClick();
        }}
      >
        링크
      </Button>
      <Modal opened={isModalOpened} onClose={() => setIsModalOpened(false)}>
        <article className="mb-32 flex flex-col gap-16">
          <InputDecorator label="주소">
            <Input
              value={selectedOptions.href}
              onChange={(e) => {
                onHrefChange(e.target.value);
              }}
            />
          </InputDecorator>
          <InputDecorator label="링크 형식">
            <Radio.Group value={selectedOptions.theme} onChange={onThemeChange}>
              <Radio.Item value="text">문자</Radio.Item>
              <Radio.Item value="primary-fill-button">검정 버튼</Radio.Item>
              <Radio.Item value="sub-fill-button">회색 버튼</Radio.Item>
              <Radio.Item value="blue-fill-button">파랑 버튼</Radio.Item>
              <Radio.Item value="image">이미지</Radio.Item>
            </Radio.Group>
          </InputDecorator>
          <InputDecorator label="버튼 사이즈">
            <Radio.Group
              readOnly={!isButtonSelected}
              value={selectedOptions.size}
              onChange={onSizeChange}
            >
              <Radio.Item value="H40">H40</Radio.Item>
              <Radio.Item value="H56">H56</Radio.Item>
            </Radio.Group>
          </InputDecorator>
          <InputDecorator label="창 열기">
            <Radio.Group
              value={selectedOptions.isOutLink ? 'out' : 'in'}
              onChange={(value) => {
                onIsOutLinkChange(value === 'out');
              }}
            >
              <Radio.Item value="out">외부에서 열기</Radio.Item>
              <Radio.Item value="in">내부에서 열기</Radio.Item>
            </Radio.Group>
          </InputDecorator>
        </article>
        <footer className="flex w-full gap-8">
          <Button
            className="flex-1"
            disabled={!selectedOptions.href}
            onClick={() => {
              setIsModalOpened(false);
              onSubmit();
            }}
          >
            설정
          </Button>
          <Button
            className="flex-1"
            theme="sub-fill"
            onClick={() => {
              setIsModalOpened(false);
            }}
          >
            취소
          </Button>
        </footer>
      </Modal>
    </>
  );
};
